import { Injectable } from '@angular/core';
import { HydraOptions } from '@arcadia/hydra';

export type IHydraConfig = Pick<
  HydraOptions,
  | 'account'
  | 'applicationId'
  | 'customerAcronym'
  | 'idleDuration'
  | 'idleEvents'
  | 'keepaliveInterval'
  | 'namespace'
  | 'timeoutDuration'
  | 'webSocketsEnabled'
  | 'domain'
>;

@Injectable({ providedIn: 'root' })
export class HydraConfig implements IHydraConfig {
  applicationId!: IHydraConfig['applicationId'];
  account!: IHydraConfig['account'];
  customerAcronym!: IHydraConfig['customerAcronym'];
  idleDuration: IHydraConfig['idleDuration'];
  idleEvents: IHydraConfig['idleEvents'];
  keepaliveInterval: IHydraConfig['keepaliveInterval'];
  namespace: IHydraConfig['namespace'];
  timeoutDuration: IHydraConfig['timeoutDuration'];
  webSocketsEnabled: IHydraConfig['webSocketsEnabled'];
  domain: IHydraConfig['domain'];
}
